module.exports = __webpack_public_path__ + "img/product07-zhinengyingxiao.2b91a628.svg";